(function () {
  'use strict';

  var modal = null;
  var content = null;
  var product = null;
  var lastFocused = null;

  function init() {
    modal = document.querySelector('[data-oddit-quickshop]');
    if (!modal) return;
    if (modal.dataset.odditQuickshopInit === 'true') return;
    modal.dataset.odditQuickshopInit = 'true';
    content = modal.querySelector('[data-oddit-quickshop-content]');
    if (!content) return;

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onKeydown);
  }

  function onDocumentClick(e) {
    var trigger = e.target.closest('[data-oddit-quickshop-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var url = trigger.getAttribute('data-quickshop-url');
      if (url) openModal(url, trigger);
      return;
    }

    if (modal.classList.contains('is-open') || modal.classList.contains('is-loading')) {
      var closer = e.target.closest('[data-oddit-quickshop-close]');
      if (closer) {
        e.preventDefault();
        closeModal();
        return;
      }

      var nav = e.target.closest('[data-quickshop-prev], [data-quickshop-next]');
      if (nav && content.contains(nav)) {
        e.preventDefault();
        var delta = nav.hasAttribute('data-quickshop-prev') ? -1 : 1;
        cycleGallery(delta);
        return;
      }

      var dot = e.target.closest('[data-quickshop-dot]');
      if (dot && content.contains(dot)) {
        e.preventDefault();
        var gallery = content.querySelector('[data-quickshop-gallery]');
        if (!gallery) return;
        var slides = gallery.querySelectorAll('[data-quickshop-slide]');
        var idx = parseInt(dot.getAttribute('data-quickshop-index'), 10);
        if (isNaN(idx)) {
          var dots = gallery.querySelectorAll('[data-quickshop-dot]');
          idx = Array.prototype.indexOf.call(dots, dot);
        }
        if (idx >= 0 && idx < slides.length) setSlide(gallery, slides, idx);
      }
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  }

  function openModal(url, trigger) {
    lastFocused = trigger || document.activeElement;
    modal.removeAttribute('hidden');
    modal.classList.add('is-loading');
    content.innerHTML = '';
    document.body.style.overflow = 'hidden';

    fetch(url, { credentials: 'same-origin' })
      .then(function (resp) {
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        return resp.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-quickshop-product]');
        if (!inner) throw new Error('quickshop content missing');
        content.appendChild(inner);

        var jsonEl = inner.querySelector('[data-quickshop-product-json]');
        if (jsonEl) {
          try { product = JSON.parse(jsonEl.textContent); }
          catch (_) { product = null; }
        }

        wireOptions(inner);
        wireAddToCart(inner);

        modal.classList.remove('is-loading');
        modal.classList.add('is-open');

        var atc = inner.querySelector('[data-quickshop-atc]');
        if (atc) {
          try { atc.focus({ preventScroll: true }); }
          catch (_) { atc.focus(); }
        }
      })
      .catch(function (err) {
        console.error('[oddit-quickshop] fetch failed', err);
        closeModal();
      });
  }

  function closeModal() {
    if (!modal) return;
    if (!modal.classList.contains('is-open') && !modal.classList.contains('is-loading')) return;
    modal.classList.remove('is-open');
    modal.classList.remove('is-loading');
    modal.setAttribute('hidden', '');
    content.innerHTML = '';
    product = null;
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) {
      try { lastFocused.focus({ preventScroll: true }); }
      catch (_) { lastFocused.focus(); }
    }
    lastFocused = null;
  }

  function cycleGallery(delta) {
    var gallery = content.querySelector('[data-quickshop-gallery]');
    if (!gallery) return;
    var slides = gallery.querySelectorAll('[data-quickshop-slide]');
    if (slides.length < 2) return;
    var current = parseInt(gallery.getAttribute('data-index'), 10) || 0;
    var next = (current + delta + slides.length) % slides.length;
    setSlide(gallery, slides, next);
  }

  function setSlide(gallery, slides, index) {
    gallery.setAttribute('data-index', String(index));
    for (var i = 0; i < slides.length; i++) {
      slides[i].classList.toggle('oddit-quickshop__slide--active', i === index);
    }
    var dots = gallery.querySelectorAll('[data-quickshop-dot]');
    for (var j = 0; j < dots.length; j++) {
      var active = j === index;
      dots[j].classList.toggle('oddit-quickshop__dot--active', active);
      if (dots[j].tagName === 'BUTTON') {
        dots[j].setAttribute('aria-selected', active ? 'true' : 'false');
      }
    }
  }

  function wireOptions(scope) {
    if (!product) return;
    scope.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'radio') return;
      updateVariant(scope);
    });
  }

  function wireAddToCart(scope) {
    var form = scope.querySelector('form.oddit-quickshop__form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var atc = form.querySelector('[data-quickshop-atc]');
      if (atc && atc.disabled) return;

      var variantInput = form.querySelector('[data-quickshop-variant-input]');
      var variantId = variantInput ? variantInput.value : '';
      if (!variantId) return;

      var qtyInput = form.querySelector('input[name="quantity"]');
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      var originalLabel = atc ? atc.textContent : null;
      if (atc) {
        atc.disabled = true;
        atc.setAttribute('aria-busy', 'true');
        atc.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: quantity }],
          sections: 'oddit-cart-drawer',
          sections_url: window.location.pathname
        })
      })
        .then(function (resp) {
          return resp.json().catch(function () { return {}; }).then(function (data) {
            if (!resp.ok) {
              var msg = (data && (data.description || data.message)) || 'Add to cart failed';
              var err = new Error(msg);
              err.data = data;
              throw err;
            }
            return data;
          });
        })
        .then(function (data) {
          closeModal();
          var cartApi = window.OdditCartDrawer;
          if (!cartApi) return;
          var sectionHTML = data && data.sections && data.sections['oddit-cart-drawer'];
          var rendered = false;
          if (sectionHTML && typeof cartApi.renderFromSection === 'function') {
            rendered = !!cartApi.renderFromSection(sectionHTML);
          }
          if (typeof cartApi.open === 'function') {
            cartApi.open(rendered ? { skipRefresh: true } : undefined);
          }
        })
        .catch(function (err) {
          console.error('[oddit-quickshop] add to cart failed', err);
          if (atc) {
            atc.disabled = false;
            atc.removeAttribute('aria-busy');
            if (originalLabel != null) atc.textContent = originalLabel;
          }
        });
    });
  }

  function updateVariant(scope) {
    if (!product) return;
    var groups = scope.querySelectorAll('[data-option-position]');
    var selected = [];
    for (var g = 0; g < groups.length; g++) {
      var pos = parseInt(groups[g].getAttribute('data-option-position'), 10);
      if (!pos) continue;
      var checked = groups[g].querySelector('input[type="radio"]:checked');
      if (checked) selected[pos - 1] = checked.value;
    }
    if (selected.length === 0) return;

    var variant = null;
    for (var v = 0; v < product.variants.length; v++) {
      var candidate = product.variants[v];
      var match = true;
      for (var i = 0; i < selected.length; i++) {
        if (candidate['option' + (i + 1)] !== selected[i]) { match = false; break; }
      }
      if (match) { variant = candidate; break; }
    }
    if (!variant) return;

    var input = scope.querySelector('[data-quickshop-variant-input]');
    if (input) input.value = variant.id;

    var price = scope.querySelector('[data-quickshop-price]');
    if (price) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        price.textContent = Shopify.formatMoney(variant.price);
      } else {
        price.textContent = '$' + (variant.price / 100).toFixed(2);
      }
    }

    var atc = scope.querySelector('[data-quickshop-atc]');
    if (atc) {
      atc.disabled = !variant.available;
      atc.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }

    if (variant.featured_image && variant.featured_image.id != null) {
      jumpGalleryToImage(scope, variant.featured_image.id);
    }
  }

  function jumpGalleryToImage(scope, imageId) {
    var gallery = scope.querySelector('[data-quickshop-gallery]');
    if (!gallery) return;
    var slides = gallery.querySelectorAll('[data-quickshop-slide]');
    for (var i = 0; i < slides.length; i++) {
      if (parseInt(slides[i].getAttribute('data-image-id'), 10) === imageId) {
        setSlide(gallery, slides, i);
        return;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
